import styled from 'styled-components';

export const ModelViewerWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  container-type: inline-size;
`;

export const ModelViewerCanvas = styled.div<{ $crosshair?: boolean }>`
  width: 100%;
  height: 100%;
  cursor: ${({ $crosshair }) => ($crosshair ? 'crosshair' : 'auto')};
`;
